import React, { ReactNode } from 'react';
import theme from '../../theme';
import { AppThemeColorVariant } from '../../../types/theme';
import { APP_THEME_COLORS, THEME_PALETTE } from '../../theme/palette';

interface IPageLayout {
  children: ReactNode;
  nestedPage?: boolean;
  className?: string;
  style?: React.CSSProperties;
  bg?: AppThemeColorVariant;
}

export default function PageLayout({
  children,
  className,
  nestedPage = false,
  bg = 'backgroundSecondary',
  style
}: IPageLayout) {
  return (
    <div 
      className={`${nestedPage ? 'w-full h-full' : 'w-screen h-screen'} flex flex-col flex-1 ${className} overflow-y-scroll`}
      style={{
        backgroundColor: THEME_PALETTE[bg],
        alignItems: nestedPage ? 'center' : undefined,
        padding: theme.sizing.x3,
        ...style
      }}>
       {
        nestedPage ? (
          <div style={{
            display: 'flex', 
            flexDirection: 'column', 
            flex: 1, 
            width: '100%',
            maxWidth: '1500px',
          }}>
            {children}
          </div>
        ) : children
       }
    </div>
  )
}